var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenewalsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 36C72 55.8821 55.8821 72 36 72C16.1177 72 0 55.8821 0 36C0 16.1177 16.1177 0 36 0C55.8821 0 72 16.1177 72 36ZM22.2545 36.3272C22.2545 28.7444 28.4171 22.5818 36 22.5818C38.3137 22.5818 40.513 23.1545 42.4145 24.1854L45.7592 20.8407C42.9415 19.0538 39.5968 18 36 18C25.8742 18 17.6727 26.2014 17.6727 36.3272H10.8L19.9636 45.491L29.1272 36.3272H22.2545ZM52.0362 27.1636L42.8728 36.3272H49.7455C49.7455 43.9103 43.583 50.0728 36 50.0728C33.6863 50.0728 31.487 49.5 29.5855 48.469L26.2407 51.8137C29.0585 53.6008 32.4032 54.6545 36 54.6545C46.1257 54.6545 54.3272 46.453 54.3272 36.3272H61.2L52.0362 27.1636Z",
    fill: "#65CC48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenewalsIcon);
export default __webpack_public_path__ + "static/media/renewals-icon.43557cf65eaed7e8a48836cea2835bd7.svg";
export { ForwardRef as ReactComponent };